import {DashboardTileModel} from '../shared/model/dashboard-tile-model';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ApiRoutes} from '../../config/api-routes';
import {Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';
import {catchError, delay, map} from 'rxjs';
import {LoggerService} from '../shared/service/logger.service';

@Injectable()
export class DashboardService {

  constructor(private httpClient: HttpClient, private routes: ApiRoutes, private loggerService: LoggerService) {
  }

  public getApplications(includeActivatable: boolean): Observable<DashboardTileModel[]> {
    let params = new HttpParams();
    if (includeActivatable)
      params = params.set('includeActivatable', 'true');
    return this.httpClient.get<DashboardTileModel[]>(this.routes.APPLICATIONS, { params: params }).pipe(
      catchError(error => {
        this.loggerService.error(error);
        return of([]);
      })
    );
  }

  public activateApplication(applicationType: string): Observable<any> {
    return this.httpClient.get(this.routes.getRouteWithInjectedParams(this.routes.APPLICATIONS_ADD, [applicationType]));
  }
}

